import { Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useMoney } from "../../../../../../../currency/useMoney"
import { toDinero } from "../../../../../../../currency/currencyLib"
import { WeekMenuProduct } from "../../../../weekMenuTypes"
import { Box, Stack } from "@mui/system"
import { StandardChip } from "../../../../../../../../shared/components/badges/StandardChip"

const useStyles = makeStyles()((theme) => ({
    content: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: "0.25rem",
    },
}))

type ProductCardInfoProps = {
    resource: WeekMenuProduct
}

export const ProductCardInfo = ({ resource }: ProductCardInfoProps) => {
    const { classes } = useStyles()
    const moneyFactory = useMoney({})

    return (
        <Stack className={classes.content}>
            {resource.headerTag && (
                <Box>
                    <StandardChip label={resource.headerTag} variant="success" size="small" />
                </Box>
            )}
            <Typography variant="h6">{resource.subject}</Typography>
            {resource.description && (
                <Typography variant="body2" color="textSecondary">
                    {resource.description}
                </Typography>
            )}
            {resource.price && (
                <Typography variant="body1" fontWeight={600}>
                    {moneyFactory.format(toDinero(resource.price))}
                </Typography>
            )}
            {!!resource.allergens?.length && (
                <Typography variant="body2" color="textSecondary">
                    Allergens: {resource.allergens.join(", ")}
                </Typography>
            )}
        </Stack>
    )
}
